/* The reference-style Buy button uses the selected Shopify variant and quantity. */
if (!window.mumanyBuyNowReady) {
  window.mumanyBuyNowReady = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-mumany-buy-now]');
    if (!button || button.disabled) return;

    const form = button.closest('form[action*="/cart/add"]');
    const message = form?.querySelector('[data-mumany-buy-error]');
    const addButton = form?.querySelector('.add-to-cart-button');
    if (!form || !message || !addButton || addButton.disabled) return;

    message.hidden = true;
    message.textContent = '';
    button.disabled = true;
    const root = window.Shopify?.routes?.root || '/';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Please check your selection and try again.');
      }
      window.location.assign(`${root}checkout`);
    } catch (error) {
      message.textContent = error.message || 'Please try again.';
      message.hidden = false;
      button.disabled = false;
    }
  });
}
